{
    "ManageCustomRoles_Title": "Sjabloon voor aangepaste rol toevoegen",
    "ManageCustomRoles_Role_Name": "Naam rolsjabloon",
    "ManageCustomRoles_Description": "Beschrijving",
    "ManageCustomRoles_Cancel": "Annuleren",
    "ManageCustomRoles_Help": "Help",
    "ManageCustomRoles_Save": "Sla",
    "NAME": "ManageCustomRoles"
}